import React from 'react';
import { render } from '@testing-library/react';
import userEvent from '@testing-library/user-event';

import { Form } from '../Form/';
import { Input } from '../Input/';

const MultipleTogglebox = () => {
	const [value, setValue] = React.useState(1);
	const handleChange = (value: number) => setValue(value);

	return (
		<Form>
			<Form.Field label="FormField1" required width="3">
				<Form.Togglebox
					control="radio"
					label="Togglebox1"
					onClick={() => handleChange(1)}
					checked={value === 1}
					className="tb1"
				/>
				<Form.Togglebox
					control="radio"
					label="Togglebox2"
					onClick={() => handleChange(2)}
					checked={value === 2}
					className="tb2"
				/>
			</Form.Field>
		</Form>
	);
};

describe('test multiple Form.Togglebox inside one Form.Field', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	const user = userEvent.setup();

	it('it should be checked on click', async () => {
		const { container } = render(<MultipleTogglebox />);

		const tbi1 = container.querySelector('.tb1 input') as HTMLInputElement;
		const tbi2 = container.querySelector('.tb2 input') as HTMLInputElement;

		expect(tbi1.checked).toEqual(true);
		expect(tbi2.checked).toEqual(false);

		await user.click(tbi2);
		expect(tbi1.checked).toEqual(false);
		expect(tbi2.checked).toEqual(true);

		await user.click(tbi1);
		expect(tbi1.checked).toEqual(true);
		expect(tbi2.checked).toEqual(false);
	});
});

const MultipleInput = () => {
	return (
		<Form>
			<Form.Field label="Label" width="3">
				<Input placeholder="First" className="input1" />
				<Input placeholder="Last" className="input2" />
			</Form.Field>
		</Form>
	);
};

describe('test focus on label clock multiple Inputs inside one Form.Field', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	const user = userEvent.setup();

	it('it should be focused on Label click', async () => {
		const { container } = render(<MultipleInput />);

		const label = container.querySelector('.Label') as HTMLElement;
		const i1 = container.querySelector('.input1 input') as HTMLInputElement;
		const i2 = container.querySelector('.input2 input') as HTMLInputElement;

		expect(i1).not.toHaveFocus();
		expect(i2).not.toHaveFocus();

		await user.click(label);
		expect(i1).toHaveFocus();
		expect(i2).not.toHaveFocus();

		await user.click(i2);
		expect(i1).not.toHaveFocus();
		expect(i2).toHaveFocus();
	});
});

describe('Counter for FormField', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should have proper number per default values', () => {
		const { container } = render(
			<Form
				key="form"
				style={{
					display: 'grid',
					gridTemplateColumns: '1fr',
					gridRowGap: 8,
					justifyItems: 'stretch',
					alignItems: 'start',
					maxWidth: '50%',
				}}
			>
				<Form.Input
					label="input"
					description="Field Helper Text"
					maxLength={20}
					showCounter
				/>
				<Form.Input
					label="input with default value"
					description="Field Helper Text"
					maxLength={20}
					showCounter
					defaultValue="With default Value"
				/>
				<Form.TextArea
					label="textarea"
					description="Field Helper Text"
					maxLength={30}
					showCounter
				/>
				<Form.TextArea
					label="textarea with default value"
					description="Field Helper Text"
					maxLength={30}
					showCounter
					defaultValue="TextArea with default value"
				/>
			</Form>
		);

		const counters = container.querySelectorAll('.FormField__counter');
		const input = counters[0].innerHTML;
		const inputWithValue = counters[1].innerHTML;
		const textArea = counters[2].innerHTML;
		const textAreaWithValue = counters[3].innerHTML;

		expect(input).toEqual('0/20');
		expect(inputWithValue).toEqual('18/20');
		expect(textArea).toEqual('0/30');
		expect(textAreaWithValue).toEqual('27/30');
	});

	it('should not show when maxLength is not defined', () => {
		const { container } = render(
			<Form
				key="form"
				style={{
					display: 'grid',
					gridTemplateColumns: '1fr',
					gridRowGap: 8,
					justifyItems: 'stretch',
					alignItems: 'start',
					maxWidth: '50%',
				}}
			>
				<Form.Input
					description="Field Helper Text"
					maxLength={20}
					showCounter
				/>
				<Form.Input description="Field Helper Text" showCounter />
				<Form.TextArea
					description="Field Helper Text"
					maxLength={30}
					showCounter
				/>
				<Form.TextArea
					description="Field Helper Text"
					showCounter
					defaultValue="TextArea with default value"
				/>
			</Form>
		);

		const counterCount = container.querySelectorAll(
			'.FormField__counter'
		).length;
		expect(counterCount).toBe(2);
	});
});

describe('Form.Field', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it.skip('should pass through data automation attributes', () => {
		const { container } = render(
			<Form>
				<Form.Field
					label="Label"
					width="3"
					data-auto-sel="automation-selector"
				>
					<Input placeholder="First" className="input1" />
					<Input placeholder="Last" className="input2" />
				</Form.Field>
			</Form>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
